// removed by extract-text-webpack-plugin
module.exports = {"listExample":"listExample-s-eqn","assessmentList":"assessmentList-3BzHN","assessmentCard":"assessmentCard-2dQ_s","paper":"paper-Li7CD"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lists/example/example.less
 ** module id = 174
 ** module chunks = 0
 **/